import { ChangeDetectionStrategy, Component, effect, ElementRef, input, model, output, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { AppText, searchQueryRequest } from 'src/app/interfaces/common';

@Component({
  selector: 'app-search-box',
  standalone: true,
  imports: [MatIcon, MatFormField, MatInputModule, MatButtonModule, FormsModule],
  templateUrl: './search-box.component.html',
  styleUrl: './search-box.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SearchBoxComponent {

  searchText = model<string>("")
  selText = input<AppText>();
  placeholderText = input<string>("")
  showButton = input<boolean>(true)
  searchTextChanged = output<searchQueryRequest>()
  searchButtonClicked = output<searchQueryRequest>()
  searchInput = viewChild<ElementRef<HTMLInputElement>>("searchInput");  // This is a signal query
  
  /*
    Angular's reactive way of running logic(side-effects) in response to changes in signals (like viewChild).
    Function inside effect will run everytime the signal searhcInput() changes.
    Since it is a query signal, it will run once when the element is ready.
  */
  readonly focusSearchInputEffect = effect(() => {
    /*
      Appearantly when it comes first the elment is ready, but not ready to call focus() on it (doesn't work),
      so we wrap it up in setTimeout() and then it always works.
      The effect() function automatically runs:
        - Once immediately when the component is initialized (indepndent from if its using any singals inside it or not)
        - Again anytime any signals used inside it change, such as in 'this.searchInput()'
    */
    setTimeout(() => {
      this.searchInput()?.nativeElement.focus();
    }, 0);
  });

  searchChange(event: InputEvent): void {
    const sq: searchQueryRequest = {
      searchValue: this.searchText().trim(),
      cameFrom: event.inputType === "insertFromPaste" ? "Paste" : "Change"
    }
    //SetTimeout here is fix for #428 (See github issues). It ensures that the inputted character is visible immideately.
    setTimeout(() => {
      this.searchTextChanged.emit(sq)
    }, 0)
    
  }

  searchClick(): void {
    const sq: searchQueryRequest = {
      searchValue: this.searchText().trim(),
      cameFrom: "Button"
    }
    this.searchButtonClicked.emit(sq)
  }
}